import { Injectable } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ShortcutService {

  private backupText = '';
  private shortcuts: { [key: string]: Observable<KeyboardEvent> } = {};

  constructor() {
    fromEvent<KeyboardEvent>(window, 'keyup')
    .subscribe(e => {
      if (!e.altKey && !e.ctrlKey && !(e.target instanceof HTMLInputElement) && !(e.target instanceof HTMLTextAreaElement)) {
        this.backupText += e.key.toUpperCase();
        while (this.backupText.length > 20) {
          const text = this.backupText.split('');
          text.shift();
          this.backupText = text.join('');
        }
      }
    });
  }

  public listen(key: string, optionals: { ctrl?: boolean, alt?: boolean } = {}): Observable<KeyboardEvent> {
    key = key.toUpperCase();
    if (this.shortcuts[key] instanceof Observable) {
      return this.shortcuts[key]
    }

    this.shortcuts[key] = fromEvent<KeyboardEvent>(window, 'keyup')
    .pipe(filter(e => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return false;
      }
      if (key.length > 1 && !optionals.alt && !optionals.ctrl && this.backupText.endsWith(key)) {
        this.backupText = this.backupText.replace(key, '');
        return true;
      }
      return (optionals.ctrl ? e.ctrlKey : true) &&
             (optionals.alt ? e.altKey : true) &&
             e.key.toUpperCase() === key &&
             key in this.shortcuts
    }));

    return this.shortcuts[key];
  }

  public delete(key: string): boolean {
    if (key in this.shortcuts) {
      delete this.shortcuts[key];
      return true;
    }
    return false;
  }

}
